module.exports = __webpack_public_path__ + "img/holla.dcab4160.png";